<script setup lang="ts">
import { useToasts } from '@glow/shared/store/toasts';
import { type AuthType } from '@glow/shared/features/auth';
import {
  HeroBlock,
  DefinitionBlock,
  AdditionalBenefitsBlock,
  ForWhomBlock,
  ChooseYourselfBlock,
  AdvantageBlock,
  HowToUseBlock,
  PartnerDifferencesBlock,
  ReviewsBlock,
  FaqBlock,
  TariffBlock,
} from '../components/blocks';
import {
  masterNavigationLinks,
  useMasterSteps,
  additionalLinks,
  masterFaqItems,
  useMasterProblemItems,
} from '../content';
import { APP_NAME } from '@glow/shared/lib/constants';
import { useRoutes } from '@glow/shared/lib/routes';

useHead({ title: 'Страница для мастеров' });

const { getUrl } = useRoutes();
const masterProblemItems = useMasterProblemItems();
const { showSuccessToast } = useToasts();

const masterSteps = useMasterSteps();
const offerButton = {
  title: 'Зарегистрироваться',
  link: '/master/register',
};
const masterRegisterLink = getUrl('masterRegisterHelpLanding');
const profileLink = getUrl('profile');

async function onAuthenticate(authType: AuthType) {
  await navigateTo(authType === 'register' ? masterRegisterLink : profileLink);
  showSuccessToast({
    title: `Вы успешно ${authType === 'register' ? 'зарегистрировались' : 'вошли'}`,
  });
}
</script>

<template>
  <div>
    <NuxtLayout
      name="landing"
      header-auth-button-title="Стать мастером"
      :navigation-links="masterNavigationLinks"
      :additional-links="additionalLinks"
      :header-main-link="{ title: 'Стать мастером', link: masterRegisterLink }"
      @authenticate="onAuthenticate"
    >
      <HeroBlock class="block" variant="partner" />
      <DefinitionBlock class="block" />
      <AdvantageBlock
        id="solve-problem"
        class="block"
        :items="masterProblemItems"
      >
        <template #title>
          <span>Решим проблемы</span>
          , которые ежедневно отнимают энергию
        </template>
      </AdvantageBlock>
      <ForWhomBlock class="block" />
      <HowToUseBlock
        class="block"
        :steps="masterSteps"
        :offer-button="offerButton"
      >
        <template #title>
          <span>Начни использовать</span>
          {{ APP_NAME }} уже сегодня
        </template>
      </HowToUseBlock>
      <PartnerDifferencesBlock class="block" />
      <ReviewsBlock class="block" />
      <ChooseYourselfBlock class="block" variant="partner" />
      <TariffBlock class="block" />
      <AdditionalBenefitsBlock class="block" />
      <FaqBlock class="block" :items="masterFaqItems" />
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.block {
  padding-bottom: stretch-size(375, 1920, 80, 150);
}
</style>
